"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT = void 0;

var _slateUtilHave = require("@canner/slate-util-have");

var DEFAULT = {
  href: "http://example.com/"
};
exports.DEFAULT = DEFAULT;

var _default = function _default(change, type) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT;

  var _Object$assign = Object.assign({}, DEFAULT, opt),
      text = _Object$assign.text,
      href = _Object$assign.href;

  var haveLinks = (0, _slateUtilHave.haveInlines)(change, type);
  if (!text) text = href;

  if (haveLinks) {
    change.unwrapInline(type);
  } else if (change.value.isExpanded) {
    change.wrapInline({
      type: type,
      data: {
        href: href
      }
    }).collapseToEnd();
  } else {
    change.insertText(text).extend(0 - text.length).wrapInline({
      type: type,
      data: {
        href: href
      }
    }).collapseToEnd();
  }

  return change;
};

exports.default = _default;